module.exports = __webpack_public_path__ + "img/sham_logo.6609ec20.png";